import React, { memo } from 'react';
import NaviBar from '@src/business-components/navibar';

const styles = require('./index.less');

/**
 * 页面包裹
 * @param children
 * @param rest
 * @returns {JSX.Element}
 * @constructor
 */
const Page = ({ children, ...rest }) => {
  return (
    <div {...rest}>
      <div className={styles.naviBarBox}>
        <NaviBar />
      </div>
      {children}

      {/*<DisplayPublicFooter />*/}
    </div>
  );
};

export default memo(Page);
